define 'controller/SimpleScrollDataLayerController', ['jquery'], ($) ->
  class SimpleScrollDataLayerController

    constructor: (@$el) ->
      @$self = @$el
      @$wasViewed= false;
      @_init()

    _init: ->
      root = @
      $(window).on 'scrollend', (e) -> root._onVisible(e, root)
    _onVisible: (e, root) ->
      if !root.$wasViewed
        el = root.$self
        if typeof jQuery == "function" && el instanceof jQuery
          el = el[0];
        rect = el.getBoundingClientRect();
        if rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          if !root.$wasViewed
            e.preventDefault();
            root.$wasViewed = true
            root._sendDatalayer()

    _sendDatalayer: ->
      try
        dataLayer.push(JSON.parse(decodeURIComponent(escape(atob(@$self.data('datalayerevent'))))))
      catch e
        try
          dataLayer.push(JSON.parse(atob(@$self.data('datalayerevent'))))
        catch e

